import { render, staticRenderFns } from "./CompositeOption.vue?vue&type=template&id=4c918c2a&scoped=true"
import script from "./CompositeOption.vue?vue&type=script&lang=js"
export * from "./CompositeOption.vue?vue&type=script&lang=js"
import style0 from "./CompositeOption.vue?vue&type=style&index=0&id=4c918c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c918c2a",
  null
  
)

export default component.exports